// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"3f034df8","147":"9fe9b391","156":"eca468d1","438":"387cc76a","706":"bdce1449","726":"61d3d778"}[chunkId] + ".chunk.js";
};